(function(){
"use strict";
// V7: sólo mejoras visuales, sin cambios a Globo.
if(new URLSearchParams(location.search).get("kira_editorial")==="0")return;
const $=(s,r=document)=>r.querySelector(s);
function updateFinishScope(){
 const guide=$(".kira-v4-finish-guide.kira-v5-single");
 const group=guide?.previousElementSibling;
 if(group && !group.classList.contains("kira-v7-finish-native") && group.querySelector("img") && !group.querySelector(".kira-tipo-funda")){
  group.classList.add("kira-v7-finish-native");
 }
}
function formatZeroDecimalPrice(){
 // Sólo cambia la visualización de precios en pesos con .00; no altera el precio almacenado
 // ni redondea importes que realmente contengan centavos.
 const root=$(".product-information .product-details");
 if(!root)return;
 const containers=root.querySelectorAll(".kira-case-price-line .price");
 for(const item of containers){
  const walker=document.createTreeWalker(item,NodeFilter.SHOW_TEXT);
  let node;
  while((node=walker.nextNode())){
   if(!node.nodeValue.includes(".00"))continue;
   const next=node.nodeValue.replace(/(\$\s*[\d,]+)\.00(?=\s*(?:MXN\b|$))/g,"$1");
   if(next!==node.nodeValue)node.nodeValue=next;
  }
 }
}
let pending=false;
function sync(){
 if(pending)return;pending=true;
 requestAnimationFrame(()=>{
  pending=false;
  try{updateFinishScope();formatZeroDecimalPrice();}
  catch(err){console.warn("[KIRA V7] Se conserva el precio y selector originales",err);}
 });
}
function start(){
 sync();
 document.addEventListener("gpoRenderCompleted",sync);
 document.addEventListener("change",sync);
 const observer=new MutationObserver(sync);
 observer.observe(document.body,{subtree:true,childList:true,characterData:true});
 setTimeout(()=>observer.disconnect(),16000);
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
else start();
})();